module.exports = __webpack_public_path__ + "img/main.96bb0744.png";